// extracted by mini-css-extract-plugin
export const sectionHtmlPane = "htmlpane-module--sectionHtmlPane--2Ob7N";